import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import emptyUserImg2 from "../../../public/images/empty.svg";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { imageLink } from "../../../actions/utility";
import MyToolTip from "../../ReuseComponenets/MyToolTip";
import AutoPlaySilentVideo from "../../website/feedTypes/feedComponents/AutoPlaySilentVideo";
import $ from 'jquery';

const MultipleUploadTutorFeed = (props) => {
  const { item } = props;
  const { feed_data, feed_label } = item;

  const currentTimeZone = moment.tz.guess();

  useEffect(() => {
    // Initialize the tooltip
    $('[data-toggle="tooltip"]').tooltip();
    
    // Apply custom style to tooltip
    $('[data-toggle="tooltip"]').on('shown.bs.tooltip', function () {
      const tooltipInner = document.querySelector('.tooltip-inner');
      if (tooltipInner) {
        tooltipInner.style.fontSize = '8px';
      }
    });

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      $('[data-toggle="tooltip"]').on('click', function () {
        const element = $(this);
        element.tooltip('show');
        
        setTimeout(() => {
          element.tooltip('hide');
        }, 2000); // Hide tooltip after 2 seconds
      });
    }

  }, []);

  return (
    <Card
      style={{
        marginBottom: "2vh",
        border: "1px #ccc solid",
        textAlign: "left",
      }}
      className="homeSection"
      id={item.user_feedid}
    >
      <CardBody>
        <div className="d-flex tutorImageSection">
          <div>
            <img
              className=""
              src={
                item.teacher_image
                  ? `https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`
                  : emptyUserImg2
              }
              width="40"
              height="40"
            />
          </div>
          <div className="ml-2">
            <label>
              {item.teacher_name}
              <strong> uploads</strong>
            </label>{" "}
            <p className="gradeName text-primary">{item.course_name}</p>
            <div className="mt-2">
              <span className="text-primary" style={{ fontSize: 14 }}>
                Sends to:
              </span>
              <br />
              {item?.student_list?.map((img) => (
                <>
                  <img
                    id={`abc${img.id}`}
                    className="rounded-circle ml-1"
                    width="30"
                    height="30"
                    src={img.image ? imageLink(img?.image) : emptyUserImg2}
                  />
                  <MyToolTip text={img.user_name} target={`abc${img.id}`} />
                </>
              ))}
            </div>
            <span style={{ fontSize: 10 }} data-toggle="tooltip" data-placement="bottom" title={item.created_at}>
              {moment
                .tz(item.created_at, "Asia/Karachi")
                .tz(currentTimeZone)
                .fromNow()}
            </span>
          </div>
        </div>

        <div className="mt-3">
        {JSON.parse(feed_data)?.[0]
                ?.message.split("/n")
                .map((part, index) => {
                  if (part.match(/^https?:\/\//i)) {
                    return (
                      <a
                        key={index}
                        href={part}
                        target="__blank"
                        className="mr-1"
                      >
                        {part}
                      </a>
                    );
                  } else {
                    return (
                      <span
                      style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
                      dangerouslySetInnerHTML={{ __html: part }}
                    ></span>
                    );
                  }
                })}
        </div>
        {feed_label !== "teacher_message_text" && (
          <Carousel showThumbs={true} dynamicHeight={true}>
            {JSON.parse(feed_data)?.map((item, index) => (
              <div>
                {item.url_type === "video" ? (
                  <AutoPlaySilentVideo video={item?.url} />
                ) : (
                  <img src={item.url} width="100%" />
                )}
              </div>
            ))}
          </Carousel>
        )}
      </CardBody>
    </Card>
  );
};

export default MultipleUploadTutorFeed;
